import { CircularProgress } from "@mui/material";

const LoadingState = () => {
    return (
        <div className="mt-8 flex justify-center items-center">
            <CircularProgress size={20} color="inherit" />
        </div>
    )
}

export default LoadingState;